import { colors } from '@/constants';
import styled from 'styled-components';

export const ModalContent = styled.div`
  padding: 20px 20px 48px 20px;
`;

export const ModalTitle = styled.h6`
  font-size: 18px;
  font-weight: 700;
  margin-top: 20px;
  text-align: center;
  margin-bottom: 32px;
  color: ${colors.gray.gray60};
  background-color: ${colors.brand.white};
`;

export const Row = styled.div`
  width: 100%;
  flex-direction: row;
  margin-bottom: 10px;
  display: inline-flex;
  justify-content: space-between;
`;

export const ProductCode = styled.div<{ $showSelo?: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  white-space: nowrap;

  color: ${colors.brand.grafite};
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 4px;
  /* line-height: 140%; */
  background-color: ${(i) => (i.$showSelo ? colors.alert.green100 : colors.gray.gray10)};
`;

export const ContentProduct = styled.div`
  width: 100%;
  gap: 16px;
  align-items: start;
  margin-bottom: 24px;
  padding-bottom: 14px;
  display: inline-flex;
  border-bottom: 1px solid ${colors.gray.gray10};
`;

export const ImageProductContent = styled.div`
  padding: 5px;
  display: grid;
  border-radius: 6px;
  place-items: center;
  border: 1px solid ${colors.background1};
`;

export const ImageProduct = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
`;

export const ProductInfos = styled.div`
  width: 100%;
`;

export const ProductDesc = styled.p`
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 24px;
  color: ${colors.brand.grafite};
`;

export const InstructionLAbel = styled.p`
  font-size: 16px;
  font-weight: 700;
  padding: 0px 10px;
  text-align: center;
  margin-bottom: 28px;
  color: ${colors.brand.grafite};
`;

export const ProductPriceLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 6px;
  color: ${colors.gray.gray60};
`;

export const RelativeValue = styled.div`
  position: relative;
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`;

export const Cifrao = styled.h6`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.brand.grafite};
`;

export const PercentageSymbol = styled.h6`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.brand.grafite};
  margin-left: 4px;
`;

export const PricesWrapper = styled.div``;

export const PricesLabelsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Value = styled.h6`
  font-size: 24px;
  font-weight: 600;
  position: absolute;
  text-align: center;
  width: -webkit-fill-available;
  color: ${colors.brand.grafite};
`;

export const InputPricesWrapper = styled.div`
  width: 100%;
  padding: 15px;
  border-radius: 6px;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 10px;
  border: 1px solid ${colors.grey8};
  box-shadow: 0px 4px 10px 0px ${colors.shadown1};
`;

export const ProductTotalPrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const ProductPercentagePrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ProductUnitPrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const InputProductUnityPrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.brand.grafite};
`;

const inputBaseStyles = `
  border: none;
  padding: 0px !important;
  text-align: center;
  font-size: clamp(1.25rem, 4vw, 1.5rem); /* 20px, 4vw, 24px */
  font-weight: 600;
  min-width: 50px;
  max-width: 100%; /* Ocupa o espaço disponível no contêiner */
  width: 100%; /* Garante que o input preencha o contêiner */
  position: relative;
  z-index: 1;
  color: ${colors.brand.grafite};
  caret-color: #676767;
  background-color: ${colors.transparent};
  -webkit-text-size-adjust: 100%; /* Safari */
  text-size-adjust: 100%; /* Outros */
  
  &:focus {
    border: none;
    outline: none;
    box-shadow: none;
  }
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Remove spinners in Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const InputProductPrice = styled.input`
  ${inputBaseStyles}
  max-width: 140px; /* Limite máximo para o input de preço total */
`;

export const InputProductPercentage = styled.input`
  ${inputBaseStyles}
  font-size: clamp(1rem, 3.5vw, 1.25rem); /* 16px, 3.5vw, 20px */
  max-width: 100px; /* Limite máximo para o input de porcentagem */
`;

export const InputProductUnitPrice = styled.input`
  ${inputBaseStyles}
  font-size: clamp(0.875rem, 3vw, 1.125rem); /* 14px, 3vw, 18px */
  max-width: 100px; /* Limite máximo para o input de preço unitário */
`;

export const ProductPrice = styled.div`
  width: 100%;
  padding: 15px;
  border-radius: 6px;
  display: inline-flex;
  justify-content: center;
  border: 1px solid ${colors.grey8};
  box-shadow: 0px 4px 10px 0px ${colors.shadown1};
`;

// Seção do slider conforme a imagem de referência
export const SliderSection = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  gap: 8px;
`;

export const PercentageIndicator = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.brand.grafite};
  margin-bottom: 4px;
`;

export const SliderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const SliderButton = styled.button<{ disabled?: boolean }>`
  background-color: ${(i) => (i.disabled ? colors.gray.gray10 : colors.brand.red)};
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: none;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 500;

  color: ${colors.brand.white};
  cursor: ${(i) => (i.disabled ? 'not-allowed' : 'pointer')};

  svg {
    font-size: 24px;
  }
`;

export const SliderWrapper = styled.div`
  flex: 1;
  position: relative;

  .input-range {
    height: 8px;
  }

  .input-range__track {
    background-color: ${colors.gray.gray20};
    height: 8px;
    border-radius: 4px;
  }

  .input-range__track--active {
    background-color: ${colors.green};
    height: 8px;
  }

  .input-range__slider {
    appearance: none;
    background: ${colors.brand.white};
    border: 3px solid ${colors.green};
    border-radius: 50%;
    cursor: pointer;
    display: block;
    height: 20px;
    margin-left: -10px;
    margin-top: -6px;
    outline: none;
    position: absolute;
    top: 50%;
    transition:
      transform 0.3s ease-out,
      box-shadow 0.3s ease-out;
    width: 20px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  }

  .input-range__slider:active {
    transform: scale(1.2);
  }

  .input-range__slider:focus {
    box-shadow: 0px 0px 0px 4px rgba(76, 175, 80, 0.2);
  }

  .input-range__label {
    display: none;
  }
`;

export const SliderLabels = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 400px;
  padding: 0 20px;
  margin-top: 4px;
`;

export const SliderLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.gray.gray60};
`;

export const BalanceContent = styled.div`
  margin-top: 18px;
  padding: 17px 15px;
  border-radius: 6px;
  background-color: ${colors.gray.gray10};
`;

export const Balance = styled.p`
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 10px;
  color: ${colors.brand.grafite};
`;

export const BalanceValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  margin-left: 10px;
`;

export const BalanceValueEmphasis = styled.span<{ $negative?: boolean }>`
  font-size: 18px;
  margin-left: 5px;
  color: ${(i) => (i.$negative ? colors.alert.red200 : colors.brand.grafite)};
`;

const themes = {
  green: colors.green,
  dark: colors.brand.grafite,
  default: colors.gray.gray20,
};

export const ApplyButton = styled.button<{
  $inactive?: boolean;
  theme?: 'green' | 'dark';
}>`
  border: none;
  padding: 13px;
  width: 100%;
  margin-top: 8px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 400;
  color: ${(i) => (i.$inactive ? colors.gray.gray40 : colors.brand.white)};
  background-color: ${(i) => (i.$inactive ? themes.default : i.theme === 'green' ? themes.green : themes.dark)};
`;

// Manter compatibilidade com versões anteriores
export const ContentFlex = styled.div`
  margin-top: 20px;
`;

export const ContentFlexWithButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
`;

export const FlexButton = styled.button`
  background-color: ${colors.gray.gray10};
  border: 1px solid ${colors.gray.gray30};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: ${colors.brand.grafite};
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.gray.gray20};
  }

  &:active {
    background-color: ${colors.gray.gray30};
  }
`;
